// ============================================================================
// AD ATTRIBUTION — capture fbclid/utm_* from the landing URL (BEO-2929)
// ============================================================================
// Reading URL params stores nothing on Meta's side and drops no cookies; the
// captured values only leave the device inside the registration payload, and
// the backend only shares them with Meta for users who granted advertising
// consent (CAPI fbc/fbp match keys).

const STORAGE_KEY = 'beoflow_ad_attribution'

const CAPTURED_PARAMS = [
  'fbclid',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
] as const

export function captureAdAttribution(search: string = window.location.search): void {
  const params = new URLSearchParams(search)
  const captured: Record<string, string> = {}
  for (const key of CAPTURED_PARAMS) {
    const value = params.get(key)?.trim()
    if (value) captured[key] = value
  }
  if (Object.keys(captured).length === 0) return
  if (captured.fbclid) {
    // Meta's fbc format needs the click-landing timestamp: fb.1.<ts>.<fbclid>
    captured.landing_ts = String(Date.now())
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...readAdAttribution(), ...captured }))
}

export function readAdAttribution(): Record<string, string> {
  try {
    const parsed: unknown = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? '{}')
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      return parsed as Record<string, string>
    }
    return {}
  } catch {
    return {}
  }
}

export function clearAdAttribution(): void {
  localStorage.removeItem(STORAGE_KEY)
}

/** The Meta pixel's first-party cookie, present only after pixel consent. */
export function readFbpCookie(): string | null {
  const match = document.cookie.match(/(?:^|;\s*)_fbp=([^;]+)/)
  return match ? match[1] : null
}
